<template>
  <div id="image-upload-quiz">
    <div>
      <div class="d-flex">
        <div
          :style="renderImageUrl"
          :class="`${vertical ? 'image-area-vertical' : 'image-area'} ${
            uploadImage.url ? 'preview-image' : null
          } `"
          @click="onUpload"
          class="upload-image"
        >
          <div v-if="!uploadImage.url" class="replace-upload">
            <div class="d-flex justifly-content-center">
              <div><icon-upload class="icon-upload mr-2" /></div>
              <div>Upload</div>
            </div>
          </div>
          <div v-if="uploadImage.url" class="replace-upload">
            <div class="d-flex justifly-content-center">
              <div><icon-upload class="icon-upload mr-2" /></div>
              <div>Replace</div>
            </div>
          </div>
        </div>
        <div class="ml-2" v-if="removable">
          <b-button
            class="btn-quiz"
            variant="outline-dark"
            @click="handleDelete"
          >
            <delete-icon class="fill-icon"
          /></b-button>
        </div>
      </div>

      <input
        ref="refInputEl"
        type="file"
        class="d-none"
        :accept="acceptFile.toString()"
        @change="handleUploadChange"
      />
      <div
        class="d-flex flex-wrap upload-button-container mt-1"
        :class="
          expectedWidth || expectedHight
            ? 'justify-content-between'
            : 'justify-content-end'
        "
      >
        <div v-if="expectedWidth || expectedHight">
          <div class="scale-container" v-if="expectedWidth">
            <span class="scale-label">{{ "W" }}</span>
            <span>{{ `: ${expectedWidth} pixel` }}</span>
          </div>
          <div class="scale-container" v-if="expectedHight">
            <span class="scale-label">{{ "H" }}</span>
            <span>{{ `: ${expectedHight} pixel` }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconUpload from "@/@core/components/svg/common/IconUpload.vue";
import useImageUpload from "./useImageUpload";
import DeleteIcon from "@/@core/components/svg/common/Trash2.vue";

export default {
  components: { IconUpload, DeleteIcon },
  props: {
    imageUrl: String,
    removable: { type: Boolean, default: false },
    pillButton: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    expectedWidth: { type: Number },
    expectedHight: { type: Number },
    acceptFile: {
      type: [String, Array],
      default: () => [".jpg", ".jpeg", ".png"],
    },
    isRequired: { type: Boolean, default: false },
  },

  setup(props) {
    const {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    } = useImageUpload(props);

    return {
      renderImageUrl,
      uploadImage,
      handleUploadChange,
      onUpload,
      handleDelete,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/quiz/image-upload.css";

#image-upload-quiz .fill-icon {
  fill: #737373;
}

#image-upload-quiz .btn-quiz.btn-outline-dark {
  background: #ffffff !important;
  border: 1px solid rgba(239, 239, 239, 1) !important;
  color: #a3a3a3 !important;
  width: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#image-upload-quiz .btn-quiz.btn-outline-dark:hover {
  background: #e05240 !important;
  border: 1px solid #e05240 !important;
}

#image-upload-quiz .btn-quiz.btn-outline-dark:hover .fill-icon {
  fill: #ffffff;
}
</style>
